var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-full flex flex-col justify-center items-center"},[(this.$parent.getImages())?_c('ImageGrid',{attrs:{"images":this.$parent.getImages()}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }